<template lang='pug' src='./lucas-difference.pug'></template>

<script>
import Loader from 'components/loader/loader'
import Hero from 'components/hero/hero-page/hero-page'
import TabLucasTabs from 'components/tab/tab-lucas-difference/tab-lucas-difference'

export default {
  name: 'lucas-difference',
  computed: {
    props () {
      return this.$store.state.pages['lucas-difference']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    if (!this.$route.hash) {
      this.$store.dispatch('VIEW_NAV', 0)
    }
  },
  components: {
    Hero,
    Loader,
    TabLucasTabs
  }
}
</script>



// WEBPACK FOOTER //
// lucas-difference.vue?2fd7a858